$(document).ready(function() {
  $('.about .nav-link#v-pills-1-tab').tab('show');
});
